class MulticolumnCounter {
  constructor(element) {
    this.element = element;
    this.target = parseFloat(element.dataset.counterTarget);
    this.prepend = element.dataset.counterPrepend || '';
    this.append = element.dataset.counterAppend || '';
    this.hasAnimated = false;
    this.duration = 2000;
    this.isDecimal = this.target % 1 !== 0;
    
    this.setupIntersectionObserver();
  }

  setupIntersectionObserver() {
    const options = {
      threshold: 0.5,
      rootMargin: '0px 0px -50px 0px'
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.hasAnimated) {
          this.hasAnimated = true;
          this.animateCounter();
        }
      });
    }, options);

    this.observer.observe(this.element);
  }

  animateCounter() {
    const startTime = performance.now();
    const startValue = 0;
    const endValue = this.target;

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / this.duration, 1);
      
      const easedProgress = this.easeOutCubic(progress);
      const currentValue = startValue + (endValue - startValue) * easedProgress;
      
      let displayValue;
      if (this.isDecimal) {
        displayValue = currentValue.toFixed(1);
      } else {
        displayValue = Math.floor(currentValue);
      }
      
      this.element.textContent = `${this.prepend}${displayValue}${this.append}`;
      
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        this.element.textContent = `${this.prepend}${this.target}${this.append}`;
        this.observer.unobserve(this.element);
      }
    };

    requestAnimationFrame(animate);
  }

  easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const counterElements = document.querySelectorAll('[data-counter-target]');
  
  counterElements.forEach(element => {
    new MulticolumnCounter(element);
  });
});

if (typeof window.initializeScrollAnimationTrigger === 'function') {
  const originalInit = window.initializeScrollAnimationTrigger;
  window.initializeScrollAnimationTrigger = function(rootEl = document) {
    originalInit(rootEl);
    
    const counterElements = (rootEl.querySelectorAll || rootEl.getElementsByTagName) 
      ? rootEl.querySelectorAll('[data-counter-target]')
      : document.querySelectorAll('[data-counter-target]');
    
    counterElements.forEach(element => {
      if (!element._counterInitialized) {
        element._counterInitialized = true;
        new MulticolumnCounter(element);
      }
    });
  };
} 